(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
if (!customElements.get('gj-footer-links')) {
  customElements.define('gj-footer-links', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 749px)');
      this.update = () => { this.querySelector('details').open = !this.media.matches; };
      this.update();
      this.media.addEventListener('change', this.update);
    }
    disconnectedCallback() { this.media?.removeEventListener('change', this.update); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mer-usp-banner')) {
    customElements.define('mer-usp-banner', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.slides = [...this.querySelectorAll('.top-announcement-bar__slide')];
        this.index = 0;
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.focused = false;
        this.toggle = this.querySelector('[data-toggle]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); this.schedule(); }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', () => { this.focused = false; this.schedule(); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        document.addEventListener('shopify:block:select', event => {
          const target = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
          if (target < 0) return;
          this.paused = true;
          this.show(target);
          this.updateToggle();
        }, options);
        this.dataset.ready = 'true';
        if (this.slides.length < 2) this.querySelectorAll('button').forEach(button => { button.hidden = true; });
        this.updateToggle();
        this.schedule();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.bound = false;
      }
      updateToggle() {
        this.toggle.setAttribute('aria-pressed', String(this.paused));
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.toggle.textContent = this.paused ? '▶' : 'Ⅱ';
      }
      show(index) {
        this.slides[this.index].hidden = true;
        this.slides[this.index].classList.remove('is-entering');
        this.index = (index + this.slides.length) % this.slides.length;
        const slide = this.slides[this.index];
        slide.hidden = false;
        slide.classList.add('is-entering');
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || this.focused || document.hidden || this.slides.length < 2) return;
        this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
